import _extends from "@babel/runtime/helpers/esm/extends";
// this file has been generated using SVGR.
// Run "yarn generate:icons" in order to generate the files for new icons.
import * as React from 'react';
import styled from 'styled-components';
import { size, color } from 'styled-system';

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 48 48",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25 20.126V8.005c0-1.333-2-1.333-2 0v12.121A4.007 4.007 0 0020.126 23H11c-1.333 0-1.333 2 0 2h9.126A4.002 4.002 0 0028 24a4.002 4.002 0 00-3-3.874zM24 26a2 2 0 100-4 2 2 0 000 4zM4 24c0 11.047 8.953 20 20 20s20-8.953 20-20S35.047 4 24 4 4 12.953 4 24zm-2 0C2 11.849 11.848 2 24 2c12.151 0 22 9.848 22 22 0 12.151-9.848 22-22 22-12.151 0-22-9.848-22-22z",
    fill: "currentColor"
  }));
};

var SvgClock = styled(SvgComponent).withConfig({
  displayName: "Clock__SvgClock",
  componentId: "al8mwh-0"
})(["", " ", ""], size, color);
export default SvgClock;